module.exports = __webpack_public_path__ + "static/media/D4_C2_001.9d0c4030.png";